export default [{
  path: '/domesticMarket',
  name: 'domesticMarket',
  component: () => import('./views/domesticMarket.vue'),
  meta: {
    title: '市场大屏'
  }
}]
